module.exports = "<p>\n  login works! Does it?\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main